export type InitialsArray = [string | undefined | null, string | undefined | null];
export type InitialsString = string | InitialsArray;

export const parseInitials = (value: InitialsString): string => {
  if (Array.isArray(value)) {
    const v: InitialsArray = [value[0] ? value[0].trim() : value[0], value[1] ? value[1].trim() : value[1]];
    if (v[0] && v[1]) {
      return `${v[0].charAt(0)}${v[1].charAt(0)}`.toUpperCase();
    } else if (v[0]) {
      return v[0].charAt(0).toUpperCase();
    } else if (v[1]) {
      return v[1].charAt(0).toUpperCase();
    }
    return "";
  } else if (value.trim().includes(" ")) {
    const parts: [string | undefined, string | undefined] = [value.trim().split(" ")[0]?.trim(), value.trim().split(" ")[1]?.trim()];
    return parseInitials(parts);
  }
  const matched = value.match(/[A-Z][a-z]+/g);
  if (matched !== null) {
    return parseInitials([matched[0], matched[1]]);
  }
  return parseInitials([value.trim().charAt(0), value.trim().charAt(1)]);
};

/**
 * converts enum values to proper words for use in Select/Multiselect/Display components
 * @param value The value to transform, e.g. "SHIP_TO_LOCATION"
 * @param transforms optional transformations:
 *                   - If Map<string, string>, lookup/value table to use instead of Title Case e.g. ["NA", "N/A"] as
 *                   the enum can not have the slash, but we want the user to see it.
 * @returns string converted to Title Case while respecting optional transforms
 */
export const enumTermToText = (value: string, transforms?: Transforms) => {
  const phrase = value
    .split("_")
    .map(w => titleCaseWord(w))
    .join(" ");

  return transforms?.entries.get(phrase) ?? phrase;
};

function titleCaseWord(word: string) {
  if (word === undefined || word === null || word.length === 0) {
    return word;
  }
  return (word[0] ?? "").toUpperCase() + word.slice(1).toLowerCase();
}

export function transforms(from: string, to: string) {
  return new Transforms(from, to);
}

class Transforms {
  entries: Map<string, string> = new Map<string, string>();

  constructor(from: string, to: string) {
    this.entries.set(from, to);
  }

  add(from: string, to: string) {
    this.entries.set(from, to);
    return this;
  }
}

export const capitalize = (input: string): string => `${input.charAt(0).toUpperCase()}${input.slice(1).toLowerCase()}`;
